// Build constants - converted to ES modules for Vite compatibility
export const appEntryPoint = 'app';

export const regularBuildOutputDir = 'dist';

export const productionSourceMap = 'source-map';
export const devSourceMap = 'cheap-module-eval-source-map';

export const sitemapPathsFile = 'sitemapPaths.json';

export const countryProfilesSplitPoint = 'countryProfiles';
export const landingSplitPoint = 'landing';

// Split points for graph pages:
export const networkSplitPoint = 'network';
export const treeSplitPoint = 'tree';
export const geoSplitPoint = 'geo';
export const feasibilitySplitPoint = 'feasibility';
export const stackSplitPoint = 'stack';
export const ringsSplitPoint = 'rings';

// Growth Projections HTML file names:
export const growthProjectionsLandingFileName = 'growthProjectionsLandingEntry';

// country profiles HTML file names:
export const countryProfilesLandingFileName = 'countryProfilesLandingEntry';
export const countryProfilesExportBasketFileName = 'countryProfilesExportBasketEntry';
export const countryProfilesExportComplexityFileName = 'countryProfilesExportComplexityEntry';
export const countryProfilesScatterPlotFileName = 'countryProfilesScatterPlotEntry';
export const countryProfilesMarketBasketFileName = 'countryProfilesMarketBasketEntry';
export const countryProfilesNewProductsFileName = 'countryProfilesNewProductsEntry';
export const countryProfilesProductSpaceIntroFileName = 'countryProfilesProductSpaceIntroEntry';
export const countryProfilesCountryProductSpaceFileName = 'countryProfilesCountryProductSpaceEntry';
export const countryProfilesRockSongFileName = 'countryProfilesRockSongEntry';
export const countryProfilesFeasibilityFileName = 'countryProfilesFeasibilityEntry';
export const countryProfilesTopProductsFileName = 'countryProfilesTopProductsEntry';
export const countryProfilesConclusionFileName = 'countryProfilesConclusionEntry';

export const staticAssetsDirectory = 'countries/static';

// ID for div used for offscreen rendering:
export const offscreenRenderingDivID = 'offscreen-rendering';

export const openGraphAssetsDirectory = 'og';

export const jsAssetType = 'js';
export const cssAssetType = 'css';

export const heroElementNames = {
  tree: 'tree map',
  geo: 'geo map',
  stack: 'stack graph',
  productSpace: 'product space',
  feasibility: 'feasibility chart',
  rings: 'rings graph',
  countryRankings: 'country rankings',
  productRankings: 'product rankings',
  growthProjectionsTable: 'growth projections table',
  growthProjectionsPressReleaseMap: 'growth projections presss release map',
};

export const performanceMetricsGAEventName = 'Performance Metrics';
export const engagementGAEventName = 'User Engagement';
export const pageLoadPerformanceMarkerName = 'atlas-page-load';
